import { atom } from "jotai";
import { BookviewSearchScope } from "organisms/panels/bookview-tab-panels/bookview-search/bookview-search-scope";

export const BookviewSearchScopeAtom = atom<BookviewSearchScope>(
    BookviewSearchScope.CurrentView
);
